<template>
  <div id="user-page" class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>フォルダ変更</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info btn_right" v-on:click="back">キャンセルする</button>
        <button id="destroyBtn" type="button" class="btn-sm btn-outline-danger btn_right" v-on:click="destroy">削除する</button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <form @submit.prevent="modify">
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>フォルダ名称</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="30" v-model="folder.folderName" class="form-control" autocomplete="off" placeholder="フォルダ名" required>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>共有先</label>
              </div>
              <div class="col-9">
                <select class="form-control" v-model="folder.type">
                  <option value="1">所属（組織）</option>
                  <option value="2">ユーザーグループ</option>
                </select>
              </div>
            </div>  
          </div>
          <div class="form-group" v-if="isOrganization">
            <div class="row">
              <div class="col-3">
                <label>所属（組織）</label>
              </div>
              <div class="col-9">
                <select v-model="folder.organizationId" class="form-control">
                  <option v-for="option in organizationOptions" v-bind:value="option.id" v-bind:key="option.id">
                    {{ option.displayName }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group"  v-if="!isOrganization">
            <div class="row">
              <div class="col-3">
                <label>ユーザーグループ</label>
              </div>
              <div class="col-9">
                <select v-model="folder.groupId" class="form-control">
                  <option v-for="option in groupOptions" v-bind:value="option.id" v-bind:key="option.id">
                    {{ option.groupName }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <button id="modify_button" type="submit" class="btn btn-info btn btn-block">更新する</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Modify',
  mixins: [sessions,path,headers],
  props: ['realms'],
  data: function(){
    return {
      message: '',
      space: '　',
      folder: {
        folderName: '',
        type: 1,
        organizationId: 0,
        groupId: 0
      },
      historyId: 0,
      organizationOptions: [],
      groupOptions: []
    }
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    },
    isOrganization: function () {
      return this.folder.type == 1
    }
  },
  beforeMount() {
    this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        var hospitalId = this.$store.getters.hospital.id
        axios
          .get("/api/organization/management/historylist/" + hospitalId, {
              headers: this.headers(accessToken)
          })
          .then(response => {
            this.historyId = response.data.data.historyId
            axios
              .post("/api/organization/management/list/",{
                hospitalId: hospitalId,
                historyId: this.historyId
              },{
                headers: this.headers(accessToken)
              }).then(response => {
                this.organizationOptions = response.data.data.organizations.map(element => {
                  var name = element.organizationName
                  element.displayName = this.space.repeat(element.hierarchyNo) + name
                  return element
                })
                this.organizationOptions.unshift({
                  id : 0,
                  groupName : ''
                })
              })
              .catch(err => {
                throw err
              })
          })
          .catch(err => {
            throw err
          })
        axios
          .get("/api/usergroup/list/" + hospitalId, {
              headers: this.headers(accessToken)
          })
          .then(response => {
            this.groupOptions = response.data.data.groups
            this.groupOptions.unshift({
              id : 0,
              groupName : ''
            })
          })
          .catch(err => {
            throw err
          })
      }
    }).catch((err) => {
        this.message = err.message
    })
  },
  mounted() {
    this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        var folderId = this.$route.params.id;
        axios.get("/api/folder/management/" + folderId, {
            headers: this.headers(accessToken)
        }).then(response => {
          var folder = response.data.data.folder
          this.folder.folderName = folder.folderName;
          var permission = response.data.data.folder.permissions[0]
          this.folder.type = permission.type;
          this.folder.organizationId = permission.organizationId
          this.folder.groupId = permission.groupId;
        }).catch(err => {
          this.message = err.message
        })
      }
    }).catch((err) => {
      this.message = err.message
    })
  },
  methods: {
    modify() {
      if (this.folder.type == 1 && this.folder.organizationId === 0) {
        this.message = "所属（組織）が選択されていません"
        return
      }
      if (this.folder.type == 2 && this.folder.groupId === 0) {
        this.message = "ユーザーグループが選択されていません"
        return
      }
      if (this.folder.type == 1) this.folder.groupId = 0
      if (this.folder.type == 2) this.folder.organizationId = 0
      if (this.folder.folderName.startsWith("maintenanceuser")) {
        this.message = "フォルダ名称を変更してください"
        return
      }
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var folderId = this.$route.params.id;
          axios.put("/api/folder/management/" + folderId, {
              folder: this.folder
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('更新されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/photo/folder/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
          this.message = err.message
      })
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/photo/folder/index'))
    },
    destroy() {
      if(confirm('削除してもよろしいですか?')){
        this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var folderId = this.$route.params.id;
          axios.delete("/api/folder/management/" + folderId, {
              headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('削除されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/photo/folder/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }}).catch((err) => {
          this.message = err.message
        })
      }
    }
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
.btn_right {
  float:right;
}
#destroyBtn {
  margin-right: 10px;
}
#modify_button {
  margin-top: 30px;
}
.times-solid{
  cursor: pointer;
  height: 15px;
  width: 15px;
}
.form-table{
  margin-top: 5px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>